import { useCallback } from 'react';
import { createStandardizedFormSubmission } from '../utils/formSubmissionUtils';
import { formatPhoneNumber } from '../utils/phoneUtils';
import { logger } from '../utils/logger';
import { getStoredInterestData } from '../utils/interestDataUtils';

export const useCarfaxSubmission = () => {
  const processCarfaxSubmission = useCallback(async (submittedFormData: { [key: string]: string }) => {
    logger.log('🔥 Processing Carfax submission');
    
    // Extract vehicle data and CARFAX_URL from stored interest data using centralized storage
    const storedInterest = await getStoredInterestData();
    const vehicleData = storedInterest?.vehicle || {};
    const carfaxUrl = vehicleData.carfax_url || '';
    
    logger.log('🔥 Vehicle data for Carfax:', vehicleData);
    logger.log('🔥 CARFAX_URL:', carfaxUrl);
    
    // Create proper form submission data
    const carfaxFormData = {
      name: submittedFormData.name,
      phone: submittedFormData.phone,
      vin: submittedFormData.vin || vehicleData.vin || ''
    };
    
    // Create standardized form submission for Carfax
    const carfaxSubmission = createStandardizedFormSubmission(
      carfaxFormData,
      'carfax',
      formatPhoneNumber,
      storedInterest
    );

    return {
      submission: carfaxSubmission,
      messageToSend: carfaxSubmission.message
    };
  }, []);

  return {
    processCarfaxSubmission
  };
};